var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerRight2"}},[_c('div',{staticClass:"bg-color-black"},[_c('div',{staticClass:"d-flex ai-center flex-column body-box"},[_c('dv-capsule-chart',{staticClass:"dv-cap-chart",staticStyle:{"height":"180px"},attrs:{"config":_vm.config}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }